import { AxiosInstance } from "axios";

import { BaseAPI } from "../../classes/BaseAPI";

export class RoomAPI extends BaseAPI {
  constructor(axios: AxiosInstance) {
    super(axios)
  }
}